import { render, staticRenderFns } from "./publicLive.vue?vue&type=template&id=8b92823c&scoped=true"
import script from "./publicLive.vue?vue&type=script&lang=js"
export * from "./publicLive.vue?vue&type=script&lang=js"
import style0 from "./publicLive.vue?vue&type=style&index=0&id=8b92823c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b92823c",
  null
  
)

export default component.exports